import type { LastActionTypeWire } from '../types/catalog-operations.api.types';

/** Action kinds with their own label; `OTHER` (and any value a newer backend adds) has none. */
const LABELLED_ACTIONS: ReadonlySet<string> = new Set<LastActionTypeWire>([
  'SAMPLE_STARTED',
  'FULL_RUN_STARTED',
  'APPROVED',
  'REJECTED',
  'RESET',
  'PAUSED',
  'RESUMED',
  'TERMINATED',
  'RETRIED',
  'ARCHIVED',
  'UNARCHIVED',
  'REPAIRED',
  'SKIPPED',
  'JUMPED_BACK',
  'RUN_STARTED',
]);

/**
 * The `common` i18n key naming a batch's last action ("Approved", "Started sample"…), or null
 * for none / `OTHER` / an unknown value — the UI then shows the actor alone.
 */
export function lastActionLabelKey(type: string | null | undefined): string | null {
  return type && LABELLED_ACTIONS.has(type) ? `actor.lastActionTypes.${type}` : null;
}
